
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutXWwfkeL_RjipD8Ip3k43jrE2D3bSFWV3JpheDnvDyfgMeta } from "/app/apps/web-landing/pages/about.vue?macro=true";
import { default as indexipxSw5er7etSPgu_45H8vdsAIXSxImHMWRXM8CHwhmiZQMeta } from "/app/apps/web-landing/pages/index.vue?macro=true";
import { default as termsbPnhe0xZgJUDYaL5NF_45SXWlq_45I178PJB9FO2D95IuOEMeta } from "/app/apps/web-landing/pages/terms.vue?macro=true";
import { default as welcome0dg3UALX_45TDuUOjk4YaasnLdFkWsWiZhV4DOPhiVco8Meta } from "/app/apps/web-landing/pages/welcome.vue?macro=true";
import { default as contact_45us45_P1AQ0gFP_45CRCx1fETwck7AKkDKLF4m94XFTzMr2sMeta } from "/app/apps/web-landing/pages/contact-us.vue?macro=true";
import { default as account_45deletion0drYvMC9HDdtR6B86pT2KoOXOMgBhNZJm_D51H3MuKQMeta } from "/app/apps/web-landing/pages/account-deletion.vue?macro=true";
import { default as transfer_45money_45_91slug_93WN5Sd1FEPY86eJGURFU_45rvAVfmdJlxwOI0g4RKKFYygMeta } from "/app/apps/web-landing/pages/transfer-money-[slug].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutXWwfkeL_RjipD8Ip3k43jrE2D3bSFWV3JpheDnvDyfgMeta || {},
    component: () => import("/app/apps/web-landing/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/web-landing/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsbPnhe0xZgJUDYaL5NF_45SXWlq_45I178PJB9FO2D95IuOEMeta || {},
    component: () => import("/app/apps/web-landing/pages/terms.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/app/apps/web-landing/pages/welcome.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/app/apps/web-landing/pages/contact-us.vue")
  },
  {
    name: "account-deletion",
    path: "/account-deletion",
    meta: account_45deletion0drYvMC9HDdtR6B86pT2KoOXOMgBhNZJm_D51H3MuKQMeta || {},
    component: () => import("/app/apps/web-landing/pages/account-deletion.vue")
  },
  {
    name: "transfer-money-slug",
    path: "/transfer-money-:slug()",
    component: () => import("/app/apps/web-landing/pages/transfer-money-[slug].vue")
  }
]